import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

const previewWidth = 300;

export default class PhotoModel extends Model {
  @attr('string') url!: string | null;
  @attr('string') s3Url!: string | null;
  @attr('number') order!: number;
  @attr('number') width!: number;
  @attr('number') height!: number;

  @belongsTo('property', {
    inverse: 'photos',
    async: false,
  })
  property!: ModelRegistry['property'];

  @cached
  get preview(): string {
    const imageUrl = this.s3Url ?? this.url;

    if (!imageUrl) {
      return '';
    }

    const separator = imageUrl.includes('?') ? '&' : '?';
    return `${imageUrl}${separator}width=${previewWidth.toString()}`;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    photo: PhotoModel;
  }
}
